function leadersDataRender() {
  let swiper = document.querySelector('.swiper-wrapper-leaders')
  fetch('./data/leaders.json')
    .then(response => {
      if (!response.ok) {
        throw new Error('Błąd w sieci.');
      }
      return response.json();
    })
    .then(data => {
      for (key of data.leaders) {
        let li = document.createElement('li');
        li.classList.add('swiper-slide');

        let name = document.createElement('h3');
        name.textContent = key.name;
        li.appendChild(name);

        let position = document.createElement('h4');
        position.textContent = key.position;
        li.appendChild(position);

        let description = document.createElement('p');
        description.textContent = key.description;
        li.appendChild(description);

        let text = document.createElement('span');
        text.textContent = key.text;
        li.appendChild(text);

        swiper.appendChild(li);
      }

      const swiperLeaders = new Swiper('.swiper-leaders', {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 20,
        grabCursor: true,
        loop: false,
        loopFillGroupWithBlank: false,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },

        breakpoints: {
          600: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 40,
          },
          1101: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 40
          }
        },

        on: {
          init: function () {
            checkControls(this);
            adjustLastGroup(this);
          },
          resize: function () {
            checkControls(this);
            adjustLastGroup(this);
          },
          slideChange: function () {
            adjustLastGroup(this);
          }
        }
      });

      function adjustLastGroup(swiper) {
        if (!swiper) return;

        const totalSlides = swiper.slides.length;
        const currentIndex = swiper.activeIndex;
        const perGroup = swiper.params.slidesPerGroup;

        const remaining = totalSlides - currentIndex;

        if (remaining <= perGroup && remaining > 0) {
          // Ostatnia niepełna grupa – przesuń tylko o tyle ile zostało
          swiper.params.slidesPerGroup = remaining;
        } else {
          // Przywróć oryginalną wartość slidesPerGroup dla aktualnego breakpointa
          const bp = swiper.currentBreakpoint;
          const original = bp
            ? swiper.originalParams.breakpoints?.[bp]?.slidesPerGroup
            : swiper.originalParams.slidesPerGroup;

          swiper.params.slidesPerGroup = original ?? perGroup;
        }
      }

      function checkControls(swiper) {
        if (!swiper) return;

        const slidesVisible =
          swiper.params.slidesPerView === 'auto'
            ? swiper.slidesPerViewDynamic()
            : swiper.params.slidesPerView;

        const totalSlides = swiper.slides.length;
        const shouldHide = totalSlides <= slidesVisible;

        if (swiper.pagination?.el) {
          swiper.pagination.el.style.display = shouldHide ? 'none' : 'flex';
        }
        if (swiper.navigation?.nextEl) {
          swiper.navigation.nextEl.style.display = shouldHide ? 'none' : 'flex';
        }
        if (swiper.navigation?.prevEl) {
          swiper.navigation.prevEl.style.display = shouldHide ? 'none' : 'flex';
        }
      }

      setTimeout(() => {
        checkControls(swiperLeaders);
        adjustLastGroup(swiperLeaders);
      }, 100);

    })
    .catch(error => {
      console.error('Wystąpił problem:', error);
    });
}
leadersDataRender();